var map = {
	"./Activities/reducer": 1677,
	"./App/reducer": 743,
	"./AwarenessCenter/CallForAction/reducer": 755,
	"./AwarenessCenter/CallForActionForm/reducer": 756,
	"./AwarenessCenter/Campaigns/AutonomousScheduler/reducer": 757,
	"./AwarenessCenter/Campaigns/CampaignReport/reducer": 758,
	"./AwarenessCenter/Campaigns/reducer": 759,
	"./AwarenessCenter/LandingPageForm/reducer": 760,
	"./AwarenessCenter/LandingPages/reducer": 761,
	"./AwarenessCenter/Scenarios/reducer": 762,
	"./AwarenessCenter/WizardCampaign/WizardCampaignEdit/reducer": 702,
	"./AwarenessCenter/WizardCampaign/WizardSimulationCampaign/reducer": 1350,
	"./AwarenessCenter/WizardCampaign/WizardSpearPhishingCampaign/reducer": 1351,
	"./AwarenessCenter/WizardCampaign/WizardTrainingCampaign/reducer": 1352,
	"./AwarenessCenter/WizardCampaign/steps/GenerateEmailsStep/reducer": 704,
	"./AwarenessCenter/WizardCampaign/steps/LandingPageStep/reducer": 529,
	"./AwarenessCenter/WizardCampaign/steps/MessageStep/reducer": 705,
	"./AwarenessCenter/WizardCampaign/steps/ReviewAndLaunchStep/reducer": 418,
	"./AwarenessCenter/WizardCampaign/steps/ScenariosStep/reducer": 703,
	"./AwarenessCenter/WizardCampaign/steps/SetupStep/reducer": 419,
	"./AwarenessCenter/WizardCampaign/steps/TrainingModuleStep/reducer": 420,
	"./AwarenessCenter/reducer": 1333,
	"./CustomizedAutoSync/reducer": 1678,
	"./DMARC/reducer": 1679,
	"./Dashboard/Ade/reducer": 763,
	"./Dashboard/Awareness/reducer": 764,
	"./Dashboard/Home/ActivityFeed/reducer": 765,
	"./Dashboard/Home/Campaigns/reducer": 766,
	"./Dashboard/Home/Deepfake/reducer": 767,
	"./Dashboard/Home/EmailOverview/reducer": 768,
	"./Dashboard/Home/InsightWidget/reducer": 769,
	"./Dashboard/Home/MailboxesStatus/reducer": 770,
	"./Dashboard/Home/ResolutionCenter/reducer": 771,
	"./Dashboard/Home/ThreatTypes/reducer": 772,
	"./Dashboard/Home/UrgentUnclassifiedIncidentsWidget/reducer": 773,
	"./Dashboard/Home/reducer": 774,
	"./Dashboard/Menu/reducer": 775,
	"./Dashboard/ThreatProtection/Flow/reducer": 776,
	"./Dashboard/ThreatProtection/IncidentOverview/reducer": 777,
	"./Dashboard/ThreatProtection/List/reducer": 778,
	"./Dashboard/VisualDetection/reducer": 779,
	"./Dashboard/reducer": 1680,
	"./EULAModal/reducer": 744,
	"./FirstLoginModal/reducer": 745,
	"./GlobalBanner/reducer": 746,
	"./GroupSettings/Assign/reducer": 780,
	"./GroupSettings/Table/reducer": 781,
	"./GroupSettings/Wizard/reducer": 782,
	"./GroupSettings/reducer": 1766,
	"./Investigation/AccountInvestigation/reducer": 783,
	"./Investigation/ThreatLog/reducer": 870,
	"./Investigation/reducer": 1767,
	"./Login/reducer": 1768,
	"./Mailboxes/Management/AddMailbox/reducer": 784,
	"./Mailboxes/Management/TagsForm/reducer": 785,
	"./Mailboxes/Management/VipDiscovery/reducer": 786,
	"./Mailboxes/Management/reducer": 787,
	"./Mailboxes/Menu/reducer": 789,
	"./Mailboxes/Segments/reducer": 790,
	"./Mailboxes/Upload/reducer": 792,
	"./Mailboxes/UserReport/reducer": 793,
	"./Mailboxes/reducer": 1769,
	"./Navigation/AccountSetup/reducer": 747,
	"./Partner/EditTenant/reducer": 794,
	"./Partner/reducer": 1770,
	"./PartnerOptions/reducer": 748,
	"./Polling/reducer": 749,
	"./ResolutionCenter/AccountTakeOverClassificationModal/reducer": 796,
	"./ResolutionCenter/AccountTakeOverModal/reducer": 797,
	"./ResolutionCenter/AffMailboxesDetail/reducer": 799,
	"./ResolutionCenter/AtoIncident/Header/reducer": 801,
	"./ResolutionCenter/AtoIncident/reducer": 802,
	"./ResolutionCenter/IncidentFilters/reducer": 803,
	"./ResolutionCenter/List/reducer": 804,
	"./ResolutionCenter/MailboxInfoModal/reducer": 805,
	"./ResolutionCenter/QuickFilters/reducer": 806,
	"./ResolutionCenter/RemediatedIncidents/reducer": 807,
	"./ResolutionCenter/Report/reducer": 808,
	"./ResolutionCenter/ReportComments/reducer": 809,
	"./ResolutionCenter/ReportCommunicationModal/reducer": 810,
	"./ResolutionCenter/ReportedIncidents/reducer": 811,
	"./ResolutionCenter/Resolution/reducer": 812,
	"./ResolutionCenter/ResolutionModal/reducer": 813,
	"./ResolutionCenter/ScanBack/reducer": 814,
	"./ResolutionCenter/ScannerDetail/reducer": 815,
	"./ResolutionCenter/ServerScan/reducer": 816,
	"./ResolutionCenter/TagsClassification/reducer": 817,
	"./ResolutionCenter/TopBar/reducer": 818,
	"./ResolutionCenter/reducer": 1771,
	"./Resources/reducer": 1772,
	"./ScenarioForm/reducer": 534,
	"./ScenarioPreview/reducer": 750,
	"./Settings/Alerts/reducer": 819,
	"./Settings/Customization/reducer": 820,
	"./Settings/CustomizationO365/Notifications/reducer": 535,
	"./Settings/CustomizationO365/ReportingReasons/reducer": 536,
	"./Settings/CustomizationO365/reducer": 1773,
	"./Settings/DeepFakeGeneral/reducer": 821,
	"./Settings/Disclaimers/reducer": 822,
	"./Settings/EmailServer/Gsuite/reducer": 823,
	"./Settings/EmailServer/O365/reducer": 824,
	"./Settings/EmailServer/QuickIntegration/reducer": 825,
	"./Settings/EmailServer/reducer": 826,
	"./Settings/General/Licenses/reducer": 827,
	"./Settings/General/reducer": 828,
	"./Settings/Incidence/reducer": 829,
	"./Settings/Intelligence/SpamAllowList/reducer": 830,
	"./Settings/Intelligence/reducer": 831,
	"./Settings/Languages/reducer": 832,
	"./Settings/MailboxProtection/LandingForm/reducer": 833,
	"./Settings/MailboxProtection/reducer": 834,
	"./Settings/MalwareDetection/reducer": 835,
	"./Settings/Menu/reducer": 836,
	"./Settings/MicrosoftQuarantine/reducer": 837,
	"./Settings/Notifications/CollaborationApps/reducer": 740,
	"./Settings/Notifications/EndUser/Editor/reducer": 838,
	"./Settings/Notifications/EndUser/Logo/reducer": 839,
	"./Settings/Notifications/EndUser/reducer": 840,
	"./Settings/Notifications/System/reducer": 841,
	"./Settings/PartnerSettings/reducer": 842,
	"./Settings/ProfileSettings/PushNotifications/reducer": 843,
	"./Settings/ProfileSettings/reducer": 844,
	"./Settings/Simulator/reducer": 845,
	"./Settings/Users/reducer": 846,
	"./Settings/Whitelist/reducer": 847,
	"./Settings/reducer": 1774,
	"./Share/reducer": 751,
	"./ShareReport/reducer": 752,
	"./Toasts/reducer": 753,
	"./UpgradeLicenseModal/reducer": 754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1676;